import { render, staticRenderFns } from "./SubscriptionList.vue?vue&type=template&id=0aa6e63c&scoped=true&"
import script from "./SubscriptionList.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionList.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionList.vue?vue&type=style&index=0&id=0aa6e63c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa6e63c",
  null
  
)

export default component.exports